import React, { useState, useEffect } from "react";
import "./CarritoTemp.css";
import { FaTrash, FaFilePdf } from "react-icons/fa";
import {
  addProductToOrder,
  createShoppingCart,
  setOrderAsInvoiced,
  validateOrder,
} from "../../services/posOrders";
import {
  addPaymentToInvoice,
  createInvoiceFromOrder,
  invoiceBanKAccountUpdate,
  payInvoice,
  validateInvoice,
} from "../../services/posInvoices";
import {
  closeShipment,
  createOrderShipment,
  validateShipment,
} from "../../services/Shipments/shipmentManagement";
import { fetchProductById } from "../../services/getProducts";

const CartTable = () => {
  const [cartItems, setCartItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [loading, setLoading] = useState(true);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [updatingVariant, setUpdatingVariant] = useState(null);
  const [showAddVariantModal, setShowAddVariantModal] = useState(false);
  const [currentProductForVariant, setCurrentProductForVariant] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [variantQuantity, setVariantQuantity] = useState(1);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);

  const asociaName = localStorage.getItem("asociaName");
  const asociaId = localStorage.getItem("asociaId");

  let userValue;
  switch (asociaName) {
    case "ASEIC":
      userValue = 1;
      break;
    case "AEMTEC":
      userValue = 2;
      break;
    case "Pablo":
      userValue = 3;
      break;
    case "Andres":
      userValue = 5;
      break;
    case "AESETEC":
      userValue = 4;
      break;
    case "ADESC":
      userValue = 6;
      break;
    default:
      userValue = null;
  }




  // PDF Generation Function
  const generatePDF = async () => {
    let watermarkImage = null;
    let watermarkImgElement = null;
    const addWatermark = (doc, pageWidth, pageHeight) => {
      if (!watermarkImage || !watermarkImgElement) return;

      const watermarkSize = 40;
      const watermarkHeight = (watermarkImgElement.height / watermarkImgElement.width) * watermarkSize;
      const watermarkX = (pageWidth - watermarkSize) / 2;
      const watermarkY = (pageHeight - watermarkHeight) / 2;

      doc.saveGraphicsState();
      doc.setGState(new doc.GState({ opacity: 0.1 }));
      doc.addImage(watermarkImage, 'PNG', watermarkX, watermarkY, watermarkSize, watermarkHeight);
      doc.restoreGraphicsState();
    };

    if (cartItems.length === 0) {
      alert("No hay productos en el carrito para generar el presupuesto.");
      return;
    }

    setIsGeneratingPdf(true);
    
    try {
      // Import jsPDF dynamically
      const { jsPDF } = await import('jspdf');
      
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      
      // Colors
      const primaryColor = '#1e40af';
      const secondaryColor = '#64748b';
      const textColor = '#1f2937';
      
        // Load and add logo
        const addLogo = () => {
        return new Promise((resolve) => {
          watermarkImgElement = new Image();
          watermarkImgElement.onload = () => {
            try {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = watermarkImgElement.width;
              canvas.height = watermarkImgElement.height;
              ctx.drawImage(watermarkImgElement, 0, 0);
              watermarkImage = canvas.toDataURL('image/png');

              // Dibujar el logo en la cabecera (top-left)
              const logoWidth = 25;
              const logoHeight = (watermarkImgElement.height / watermarkImgElement.width) * logoWidth;
              doc.addImage(watermarkImage, 'PNG', 15, 8, logoWidth, logoHeight);

              resolve();
            } catch (error) {
              console.warn('Error al agregar logo:', error);
              resolve(); // continuar sin logo
            }
          };
          watermarkImgElement.onerror = () => {
            console.warn('No se pudo cargar el logo desde /images/logo.png');
            resolve();
          };
          watermarkImgElement.src = '/images/logo.png';
        });
      };

      // Add logo first
      await addLogo();
      
      // Header - Company Info
      doc.setFillColor(30, 64, 175); // Primary blue
      doc.rect(0, 0, pageWidth, 40, 'F');
      
      // Ahora agrega el logo principal (no la marca de agua)
      await addLogo(); // carga el logo y lo dibuja en la cabecera
      addWatermark(doc, pageWidth, pageHeight); // agrega la marca de agua en la primera página
      
      // Company Name (moved right to make space for logo)
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(24);
      doc.setFont('helvetica', 'bold');
      doc.text('VOLTEON ELECTRONICS', 45, 25);
      
      // Company Details
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.text('volteonelectronics.com', 45, 32);
      doc.text('Tel: +506 6386-5580', pageWidth - 60, 32);
      
      // Title
      doc.setTextColor(textColor);
      doc.setFontSize(18);
      doc.setFont('helvetica', 'bold');
      doc.text('PRESUPUESTO', 20, 60);
      
      // Date
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      const currentDate = new Date().toLocaleDateString('es-CR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
      doc.text(`Fecha: ${currentDate}`, 20, 70);
      
      // Quote number (random for demo)
      const quoteNumber = 'PRES-' + Math.floor(Math.random() * 10000).toString().padStart(4, '0');
      doc.text(`Presupuesto No: ${quoteNumber}`, 20, 78);
      
      // Products table header
      let yPosition = 95;
      doc.setFillColor(100, 116, 139); // Secondary gray
      doc.rect(20, yPosition, pageWidth - 40, 8, 'F');
      
      doc.setTextColor(255, 255, 255);
      doc.setFont('helvetica', 'bold');
      doc.text('Producto', 25, yPosition + 5);
      doc.text('Cant.', pageWidth - 80, yPosition + 5);
      doc.text('Precio Unit.', pageWidth - 60, yPosition + 5);
      doc.text('Total', pageWidth - 30, yPosition + 5);
      
      yPosition += 12;
      
      // Products
      doc.setTextColor(textColor);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      
      let totalAmount = 0;
      
      const itemsToShow = cartItems.filter(item => !item.isContainerOnly);
      
      itemsToShow.forEach((item) => {
        if (yPosition > pageHeight - 40) {
          doc.addPage();
          yPosition = 30;
          addWatermark(doc, pageWidth, pageHeight);
        }
        
        const itemTotal = item.price * item.cantidad;
        totalAmount += itemTotal;
        
        // Product name (with variant info if applicable)
        let productName = item.label;
        // if (item.isVariant && item.variantInfo) {
        //   productName += ` (${item.variantInfo.value})`;
        // }
        
        // Truncate long product names
        if (productName.length > 40) {
          productName = productName.substring(0, 37) + '...';
        }
        
        doc.text(productName, 25, yPosition);
        doc.text(item.cantidad.toString(), pageWidth - 78, yPosition);
        doc.text(` ${item.price.toLocaleString()}`, pageWidth - 65, yPosition);
        doc.text(` ${itemTotal.toLocaleString()}`, pageWidth - 35, yPosition);
        
        yPosition += 6;
      });
            
      // Total section
      yPosition += 10;

      // Establece opacidad antes de dibujar el rectángulo
      doc.saveGraphicsState();
      doc.setGState(new doc.GState({ opacity: 0.3 })); // 0.3 es más transparente

      doc.setFillColor(240, 249, 255);
      doc.rect(pageWidth - 100, yPosition - 5, 80, 15, 'F');

      // Restaura opacidad para el resto del contenido
      doc.restoreGraphicsState();
      
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(12);
      doc.text('TOTAL (Colones):', pageWidth - 90, yPosition + 5);
      doc.text(`${totalAmount.toLocaleString()}`, pageWidth - 45, yPosition + 5);
      
      // Company message
      yPosition += 30;
      doc.setFont('helvetica', 'italic');
      doc.setFontSize(10);
      doc.setTextColor(100, 116, 139);
      
      const message = 'En Volteon, transformamos tus proyectos en realidad, con los mejores componentes electrónicos';
      
      // Center the message
      const messageWidth = doc.getTextWidth(message);
      const messageX = (pageWidth - messageWidth) / 2;
      doc.text(message, messageX, yPosition);
      
      // Terms and conditions
      yPosition += 20;
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      doc.setTextColor(secondaryColor);
      
      const terms = [
        '• Los precios están sujetos a cambios sin previo aviso.',
        '• Para consultas adicionales, contáctanos al +506 6386-5580.',
        '• Visita nuestra página web: volteonelectronics.com'
      ];
      
      terms.forEach(term => {
        doc.text(term, 20, yPosition);
        yPosition += 5;
      });
      
      // Footer
      doc.setFillColor(30, 64, 175);
      doc.rect(0, pageHeight - 15, pageWidth, 15, 'F');
      
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');
      doc.text('© 2025 Volteon Electronics - Todos los derechos reservados', 20, pageHeight - 8);
      
      // Save the PDF
      const fileName = `Presupuesto_Volteon_${quoteNumber}_${new Date().toISOString().split('T')[0]}.pdf`;
      doc.save(fileName);
      
      alert(`Presupuesto generado exitosamente: ${fileName}`);
      
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Hubo un error al generar el PDF. Por favor, inténtelo de nuevo.');
    } finally {
      setIsGeneratingPdf(false);
    }
  };

  useEffect(() => {
    const fetchCartItems = async () => {
      setLoading(true);
      const storedCart = JSON.parse(localStorage.getItem("carritoActual")) || [];

      const updatedCart = await Promise.all(
        storedCart.map(async (item) => {
          const productData = await fetchProductById(item.id);
          const userStock =
            productData.stock_reel.find((stock) => stock.label === asociaName)?.real || 0;

          const isVariant = item.parentProductId !== undefined;

          return {
            ...item,
            label: productData.label,
            basePrice: parseFloat(productData.price),
            price: parseFloat(productData.price),
            description: productData.description,
            image: productData.image,
            userStock,
            variants: !isVariant ? productData.variants || [] : [],
            isVariant,
            variantInfo: isVariant ? item.variantInfo : null,
            isContainerOnly: !isVariant && (item.isContainerOnly || false),
          };
        })
      );
      setCartItems(updatedCart);
      setLoading(false);
    };

    fetchCartItems();
  }, []);

  const handleDelete = (productId, parentId) => {
    let updatedCart;

    if (parentId) {
      updatedCart = cartItems.filter(
        (item) => !(item.id === productId && item.parentProductId === parentId)
      );

      const parentProduct = cartItems.find((item) => item.id === parentId);
      const remainingVariants = updatedCart.filter(
        (item) => item.parentProductId === parentId
      );

      if (
        parentProduct &&
        parentProduct.isContainerOnly &&
        remainingVariants.length === 0
      ) {
        updatedCart = updatedCart.filter((item) => item.id !== parentId);
      }
    } else {
      updatedCart = cartItems.filter(
        (item) => item.id !== productId && item.parentProductId !== productId
      );
    }

    setCartItems(updatedCart);
    localStorage.setItem("carritoActual", JSON.stringify(updatedCart));
    alert("Producto eliminado del carrito.");
  };

  const openAddVariantModal = (product) => {
    if (product.variants && product.variants.length > 0) {
      const hasVariantsInCart = cartItems.some(
        (item) => item.parentProductId === product.id
      );

      if (!hasVariantsInCart) {
        const updatedCart = cartItems.map((item) => {
          if (item.id === product.id) {
            return { ...item, isContainerOnly: true };
          }
          return item;
        });
        setCartItems(updatedCart);
        localStorage.setItem("carritoActual", JSON.stringify(updatedCart));
      }
    }

    setCurrentProductForVariant(product);
    setSelectedVariant(
      product.variants.length > 0 ? product.variants[0] : null
    );
    setVariantQuantity(1);
    setShowAddVariantModal(true);
  };

  const clearCart = () => {
    setCartItems([]);
    localStorage.removeItem("carritoActual");
    alert("El carrito ha sido limpiado.");
  };

  const toggleContainerOnly = (productId) => {
    const updatedCart = cartItems.map((item) => {
      if (item.id === productId) {
        return { ...item, isContainerOnly: !item.isContainerOnly };
      }
      return item;
    });

    setCartItems(updatedCart);
    localStorage.setItem("carritoActual", JSON.stringify(updatedCart));
  };

  const handleAddVariant = async () => {
    if (!selectedVariant || !currentProductForVariant) return;

    setUpdatingVariant(currentProductForVariant.id);

    try {
      const productData = await fetchProductById(selectedVariant.fk_product_child);
      const userStock =
        productData.stock_reel.find((stock) => stock.label === asociaName)?.real || 0;

      const variantItem = {
        id: selectedVariant.fk_product_child,
        parentProductId: currentProductForVariant.id,
        cantidad: variantQuantity,
        label: productData.label,
        basePrice: parseFloat(productData.price),
        price:
          parseFloat(productData.price) +
          parseFloat(selectedVariant.variation_price),
        description: productData.description,
        image: productData.image,
        userStock,
        isVariant: true,
        variantInfo: {
          value: selectedVariant.value,
          parentName: currentProductForVariant.label,
        },
      };

      const existingVariantIndex = cartItems.findIndex(
        (item) =>
          item.id === variantItem.id &&
          item.parentProductId === variantItem.parentProductId
      );

      let newCartItems;

      if (existingVariantIndex >= 0) {
        newCartItems = [...cartItems];
        newCartItems[existingVariantIndex].cantidad += variantQuantity;
      } else {
        newCartItems = [...cartItems, variantItem];
      }

      const parentIndex = newCartItems.findIndex(
        (item) => item.id === currentProductForVariant.id
      );
      if (parentIndex >= 0) {
        newCartItems[parentIndex] = {
          ...newCartItems[parentIndex],
          isContainerOnly: true,
        };
      }

      setCartItems(newCartItems);
      localStorage.setItem("carritoActual", JSON.stringify(newCartItems));

      setShowAddVariantModal(false);
      alert(`Agregado: ${variantQuantity} unidades de ${selectedVariant.value}`);
    } catch (error) {
      console.error("Error al agregar variante:", error);
      alert("Hubo un error al agregar la variante");
    } finally {
      setUpdatingVariant(null);
    }
  };

  const handlePay = async () => {
    try {
      setIsProcessingPayment(true);

      const response = await createShoppingCart(asociaId);
      const orderId = response;

      const itemsToOrder = cartItems.filter((item) => !item.isContainerOnly);
      await addProductsToOrder(orderId, itemsToOrder);

      setCartItems([]);
      await validateOrder(orderId);
      await processInvoice(parseInt(orderId));
      await setOrderAsInvoiced(orderId);

      const shipmentCreated = await createOrderShipment(parseInt(orderId), userValue);
      await validateShipment(shipmentCreated);
      await closeShipment(shipmentCreated);

      alert("Pago realizado con éxito!");
      localStorage.removeItem("carritoActual");
      setShowModal(false);
      window.location.reload();
    } catch (error) {
      console.error("Error al procesar el pago:", error);
      alert(
        "Hubo un error al procesar el pago. Por favor, limpie el carrito, recargue la página e inténtelo de nuevo."
      );
    } finally {
      setIsProcessingPayment(false);
    }
  };

  const addProductsToOrder = async (orderId, itemsToOrder) => {
    const addProductPromises = itemsToOrder.map((item) => {
      const productData = {
        id: item.id,
        qty: item.cantidad,
        subprice: item.price,
      };
      return addProductToOrder(orderId, productData);
    });
    await Promise.all(addProductPromises);
  };

  const processInvoice = async (orderId) => {
    const invoiceId = await createInvoiceFromOrder(orderId);
    await validateInvoice(parseInt(invoiceId.id));
    await invoiceBanKAccountUpdate(parseInt(invoiceId.id), parseInt(paymentMethod));
    await addPaymentToInvoice(parseInt(invoiceId.id));
  };

  const totalAmount = cartItems
    .filter((item) => !item.isContainerOnly)
    .reduce((total, item) => total + item.price * item.cantidad, 0);

  const mainProducts = cartItems.filter((item) => !item.isVariant);
  const variantsByParent = {};

  cartItems.forEach((item) => {
    if (item.isVariant && item.parentProductId) {
      if (!variantsByParent[item.parentProductId]) {
        variantsByParent[item.parentProductId] = [];
      }
      variantsByParent[item.parentProductId].push(item);
    }
  });

  return (
    <div className="cart-container">
      <h2 className="cart-heading">Carrito de Compras</h2>
      {loading ? (
        <div className="loading">Cargando productos...</div>
      ) : cartItems.length === 0 ? (
        <p>No hay productos en el carrito.</p>
      ) : (
        <div>
          <table className="cart-table">
            <thead>
              <tr>
                <th className="cart-table-header">Producto</th>
                <th className="cart-table-header">Cantidad</th>
                <th className="cart-table-header">Precio</th>
                <th className="cart-table-header">Stock</th>
                <th className="cart-table-header">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {mainProducts.map((item) => (
                <React.Fragment key={item.id}>
                  <tr
                    className={`cart-table-row ${
                      item.isContainerOnly ? "container-only-row" : ""
                    }`}
                  >
                    <td className="cart-table-cell">
                      <strong>{item.label}</strong>
                      {item.isContainerOnly && (
                        <span className="container-badge">Solo contenedor</span>
                      )}
                    </td>
                    <td className="cart-table-cell">
                      {item.isContainerOnly ? "-" : item.cantidad}
                    </td>
                    <td className="cart-table-cell">
                      {item.isContainerOnly ? "-" : `${item.price} ₡`}
                    </td>
                    <td className="cart-table-cell">{item.userStock}</td>
                    <td className="cart-table-cell">
                      <button
                        className="cart-delete-button"
                        onClick={() => handleDelete(item.id)}
                      >
                        <FaTrash />
                      </button>

                      {item.variants && item.variants.length > 0 && (
                        <button
                          className="cart-add-variant-button"
                          onClick={() => openAddVariantModal(item)}
                        >
                          + Agregar Variante
                        </button>
                      )}

                      {variantsByParent[item.id] &&
                        variantsByParent[item.id].length > 0 && (
                          <button
                            className={`cart-toggle-container-button ${
                              item.isContainerOnly ? "active" : ""
                            }`}
                            onClick={() => toggleContainerOnly(item.id)}
                            title={
                              item.isContainerOnly
                                ? "Incluir producto principal en la venta"
                                : "Usar solo como contenedor de variantes"
                            }
                          >
                            {item.isContainerOnly ? "☐" : "☑"}
                          </button>
                        )}
                    </td>
                  </tr>

                  {variantsByParent[item.id] &&
                    variantsByParent[item.id].map((variant) => (
                      <tr
                        key={`${variant.parentProductId}-${variant.id}`}
                        className="cart-table-row variant-row"
                      >
                        <td className="cart-table-cell variant-cell">
                          -- {variant.variantInfo.value}
                        </td>
                        <td className="cart-table-cell">{variant.cantidad}</td>
                        <td className="cart-table-cell">{`${variant.price} ₡`}</td>
                        <td className="cart-table-cell">{variant.userStock}</td>
                        <td className="cart-table-cell">
                          <button
                            className="cart-delete-button"
                            onClick={() =>
                              handleDelete(variant.id, variant.parentProductId)
                            }
                          >
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {cartItems.length > 0 && (
        <div className="cart-buttons">
          <button
            onClick={() => setShowModal(true)}
            className="cart-view-button"
          >
            Pagar
          </button>

          <button onClick={clearCart} className="cart-clear-button">
            Limpiar Carrito
          </button>

          <button 
            onClick={generatePDF} 
            className="cart-pdf-button"
            disabled={isGeneratingPdf}
          >
            <FaFilePdf />
            {isGeneratingPdf ? "Generando..." : "Generar Presupuesto"}
          </button>
        </div>
      )}

      {/* Payment Modal */}
      {showModal && (
        <div className="cart-modal">
          <div className="cart-modal-content">
            <h1 style={{ color: "#000" }}>
              Total de la Orden: ₡{totalAmount.toFixed(0)}
            </h1>
            <div className="order-summary">
              <h3>Resumen de productos:</h3>
              <ul>
                {cartItems
                  .filter((item) => !item.isContainerOnly)
                  .map((item, index) => (
                    <li key={index}>
                      {item.cantidad} x {item.label}
                      {item.isVariant && ` (${item.variantInfo.value})`}: ₡
                      {(item.price * item.cantidad).toFixed(0)}
                    </li>
                  ))}
              </ul>
            </div>
            <div>
              <label htmlFor="confirmCheckbox">
                Confirmo haber recibido el pago.
              </label>
              <input
                type="checkbox"
                id="confirmCheckbox"
                checked={isConfirmed}
                onChange={() => setIsConfirmed(!isConfirmed)}
              />
            </div>
            <p>Seleccione el método de pago efectuado:</p>
            <div>
              <input
                type="radio"
                id="sinpeMovil"
                name="paymentMethod"
                value="106"
                checked={paymentMethod === "106"}
                onChange={(e) => setPaymentMethod(e.target.value)}
              />
              <label htmlFor="sinpeMovil">Sinpe Móvil</label>
              <input
                type="radio"
                id="efectivo"
                name="paymentMethod"
                value="4"
                checked={paymentMethod === "4"}
                onChange={(e) => setPaymentMethod(e.target.value)}
              />
              <label htmlFor="efectivo">Efectivo</label>
            </div>
            {paymentMethod === "106" && <p>Sinpe: 6386-5580</p>}
            <div className="modal-buttons">
              <button
                onClick={handlePay}
                className="cart-view-button"
                disabled={!isConfirmed || !paymentMethod || isProcessingPayment}
              >
                {isProcessingPayment ? "Procesando pago..." : "Confirmar Pago"}
              </button>
              <button
                onClick={() => setShowModal(false)}
                className="cart-view-button"
                disabled={isProcessingPayment}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Variant Modal */}
      {showAddVariantModal && currentProductForVariant && (
        <div className="cart-modal">
          <div className="cart-modal-content">
            <h2 style={{ color: "#000" }}>
              Agregar variante para {currentProductForVariant.label}
            </h2>

            <div className="variant-selection">
              <label htmlFor="variantSelect">Seleccionar variante:</label>
              <select
                id="variantSelect"
                value={selectedVariant?.fk_product_child || ""}
                onChange={(e) => {
                  const selected = currentProductForVariant.variants.find(
                    (v) => v.fk_product_child === e.target.value
                  );
                  setSelectedVariant(selected);
                }}
              >
                {currentProductForVariant.variants.map((variant) => (
                  <option
                    key={variant.fk_product_child}
                    value={variant.fk_product_child}
                  >
                    {variant.value}
                  </option>
                ))}
              </select>
            </div>

            <div className="quantity-selection">
              <label htmlFor="quantityInput">Cantidad:</label>
              <input
                type="number"
                id="quantityInput"
                min="1"
                value={variantQuantity}
                onChange={(e) =>
                  setVariantQuantity(parseInt(e.target.value) || 1)
                }
              />
            </div>

            <div className="modal-buttons">
              <button
                onClick={handleAddVariant}
                className="cart-view-button"
                disabled={
                  !selectedVariant || variantQuantity < 1 || updatingVariant
                }
              >
                {updatingVariant ? "Agregando..." : "Agregar al Carrito"}
              </button>
              <button
                onClick={() => setShowAddVariantModal(false)}
                className="cart-view-button"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartTable;